<script>
  // @ts-check
  import DynamicHeading from "../atoms/DynamicHeading.svelte";
  import DynamicHeadingContext from "../atoms/DynamicHeadingContext.svelte";
  import Link from "../atoms/Link.svelte";
  import WithPattern from "../atoms/WithPattern.svelte";
  import { getTheme } from "../utilities/themes";
  import { v4 as uuid } from "@lukeed/uuid";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * The title of the component
   * @type {string}
   */
  export let title;

  /**
   * The optional eyebrow text of the component
   * @type {string}
   */
  export let eyebrow = null;

  /**
   * The call to action for the component
   * @type {import('../types/shared.js').CTA}
   */
  export let cta = null;

  /**
   * The theme of the component
   * @type {import('../utilities/themes.js').ThemeName}
   */
  export let theme = "lightBlue";

  let currentTheme = getTheme(theme ?? "lightBlue");

  let isLinkHovered = false;
  let linkId = uuid();

  const pseudoElementClass =
    "before:absolute before:top-0 before:left-0 before:w-full before:h-full";
</script>

<DynamicHeadingContext>
  <WithPattern
    {id}
    name={currentTheme.pattern}
    class="{currentTheme.backgroundColor} {currentTheme.textColor} p-8 md:p-10 lg:h-fit lg:min-h-full lg:p-12.5 xl:p-15"
  >
    {#if eyebrow}
      <p class="heading-xs pb-4 md:pb-5 lg:pb-6 xl:pb-8">
        {eyebrow}
      </p>
    {/if}
    <DynamicHeading class="heading-md">
      {#if cta}
        <a
          href={cta.url}
          target={cta.url && cta.isExternal ? "_blank" : null}
          rel={cta.url && cta.isExternal ? "noopener noreferrer" : null}
          aria-describedby={linkId}
          class="no-underline outline-none {pseudoElementClass}"
          data-sveltekit-reload
          on:mouseenter={() => (isLinkHovered = true)}
          on:mouseleave={() => (isLinkHovered = false)}
        >
          {title}
        </a>
      {:else}
        {title}
      {/if}
    </DynamicHeading>
    {#if cta}
      <Link
        class="mt-10 lg:mt-20 "
        href={cta.url}
        isExternal={cta.isExternal}
        label={cta.text}
        variant="large"
        {theme}
        {isLinkHovered}
      />
    {/if}
  </WithPattern>
</DynamicHeadingContext>
